<template>
  <div class="substep-investigate-individual-members">
    <div class="substep-header">
      <h3 data-testid="insights-onboarding-substep-title">Investigate individual members</h3>
      <p>
        Dig deeper to understand why members are flagged for unusual activity.
        <br>
        Hubstaff Insights automatically tracks apps, URLs, activity breakdown, and even screenshots!
      </p>
    </div>
    <div class="substep-body">
      <div class="confidence-score">
        <h4>Activity classification</h4>
        <div class="confidence-score-header">
          <div>
            <AppAvatar
              size="speck"
              :avatar="user.avatar"
            />
            <span>{{ user.name }}</span>
          </div>
          <InsightsUnusualActivityConfidenceBadgeLarge :confidence-level="confidenceLevel" />
        </div>
        <div class="description">
          {{ user.name }} was given a high risk score, with <strong>over 36 hours of unusual activity</strong> during the previous 30 days.
        </div>
        <div class="separator" />
        <div class="suspicious-application">
          <h4>Suspicious application</h4>
          <p>We detected an application running that can produce fake activity.</p>
          <div class="auto-clicker d-inline-flex z-bg-gray-100 small rounded-4 strong px-6 py-2">AutoClicker</div>
        </div>
        <div class="separator" />
        <div class="top-urls">
          <div class="control-label d-block mb-10">Top URLs visited</div>
          <div class="urls d-flex flex-wrap gap-8">
            <div class="d-inline-flex z-bg-gray-100 small rounded-4 strong px-6 py-2">google.com - 10%</div>
            <div class="d-inline-flex z-bg-gray-100 small rounded-4 strong px-6 py-2">reddit.com - 80%</div>
            <div class="d-inline-flex z-bg-gray-100 small rounded-4 strong px-6 py-2">calendar.google.com - 10%</div>
          </div>
        </div>
        <div class="top-apps">
          <div class="control-label d-block mb-10">Top Apps in use</div>
          <div class="apps d-flex flex-wrap gap-8">
            <div class="auto-clicker d-inline-flex z-bg-gray-100 small rounded-4 strong px-6 py-2">AutoClicker - 80%</div>
            <div class="d-inline-flex z-bg-gray-100 small rounded-4 strong px-6 py-2">Spotify - 15%</div>
            <div class="d-inline-flex z-bg-gray-100 small rounded-4 strong px-6 py-2">Discord - 5%</div>
          </div>
        </div>
        <div class="duration-breakdown">
          <div class="duration">
            <div class="control-label d-block mb-4">Duration</div>
            <div class="value">{{ humanDuration }}</div>
          </div>
          <div class="activity-breakdown">
            <div class="control-label d-block mb-10">Activity breakdown</div>
            <div class="content small w-full">
              <div class="mouse">
                <div class="progress-bar z-bg-green-100 w-full">
                  <div
                    class="progress-bar green"
                    :style="{ width: `${instancePercentage(duration.mouse, duration.total)}%` }"
                  />
                </div>
                <div class="percentage">
                  <div class="legend green" />
                  <div class="no-wrap">{{ secondsToHours(duration.mouse) }} - Mouse</div>
                </div>
              </div>
              <div class="keyboard">
                <div class="progress-bar z-bg-orange-100 w-full">
                  <div
                    class="progress-bar orange"
                    :style="{ width: `${instancePercentage(duration.keyboard, duration.total)}%` }"
                  />
                </div>
                <div class="percentage">
                  <div class="legend orange" />
                  <div class="no-wrap">{{ secondsToHours(duration.keyboard) }} - Keyboard</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InsightsUnusualActivityConfidenceBadgeLarge from '~/components/insights/InsightsUnusualActivityConfidenceBadgeLarge.vue';
import { secondsToHours } from '~/utils/time_utils';

export default {
  name: 'InvestigateIndividualMembers',
  components: {
    InsightsUnusualActivityConfidenceBadgeLarge,
  },
  props: {
    confidenceLevel: {
      type: Number,
      required: true,
    },
    duration: {
      type: Object,
      required: true,
    },
    humanDuration: {
      type: String,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  beforeMount() {
    this.$emit('completeSubstep');
  },
  methods: {
    instancePercentage(instance, total) {
      return Math.round((instance / total) * 100);
    },
    secondsToHours,
  },
};
</script>
